import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Edit from "./Edit.js"
import Detail from "./Detail.js"
import Avanzar from "./Avanzar.js"
import SubirDocumento from './SubirDocumento.js'
import DescargarDoc from './DescargarDoc.js'


import ParadigmaTable from "../../../components/ParadigmaTable/"
import DateFilter from "../../../components/ParadigmaTable/DateFilter";

import Enums from "../EstadoEnum.js"


import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import dateFunctions from '../../functions/dateFunctions';

class PlanDeTrabajo extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.solicitud__codigo.toUpperCase()),
                    show: true,
                },
                {
                    Header: "Código Interno",
                    id: "solicitud__codigo",
                    accessor: "solicitud__codigo",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fecha),
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Título",
                    id: "solicitud__nombre",
                    accessor: "solicitud__nombre",
                    show: true,
                },
                {
                    Header: "Empresa/Organización",
                    id: "solicitud__empresa__nombre",
                    accessor: d => d.solicitud__empresa__nombre,
                    show: true,
                },
                {
                    Header: "Tipo de Transferencia",
                    id: "tipo__nombre",
                    accessor: "tipo__nombre",
                    show: true,
                },
                {
                    Header: "Subtipo de Transferencia",
                    id: "subtipo__nombre",
                    accessor: "subtipo__nombre",
                    show: true,
                },
                {
                    Header: "Modo de Vinculación",
                    id: "marco__nombre",
                    accessor: "marco__nombre",
                    show: true,
                },
                {
                    Header: "LTP",
                    id: "ltp_nombre",
                    accessor: "ltp_nombre",
                    show: true,
                },
                {
                    Header: "Grupo",
                    id: "departamento_nombre",
                    accessor: "departamento_nombre",
                    show: true,
                },
                {
                    Header: "Observaciones",
                    id: "observaciones",
                    accessor: d => d.observaciones,
                    show: true,
                },
                {
                    Header: "Documento",
                    id: "urldocumento",
                    filterable: false,
                    accessor: d => d.urldocumento,
                    show: true,
                    Cell: props => (props.value != '' ? <a target={"_blank"} href={props.value}>DESCARGAR</a> : ''),
                    width: 100,
                },

                {
                    Header: "FechaEstado",
                    id: "fechaEstado",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaEstado),
                    show: false,
                    private: true
                },
                {
                    Header: "Estado",
                    id: "strestado",
                    show: true,
                    width: 200,
                    className: "text-center",
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="EN ANALISIS">EN ANÁLISIS</option>
                            <option value="CARGANDO PLAN DE TRABAJO">CARGANDO PLAN DE TRABAJO</option>
                            <option value="AVANZADO A PRESUPUESTO">AVANZADO A PRESUPUESTO</option>
                        </select>,
                    accessor: d => {
                        if (d.strestado == "CARGANDO PLAN DE TRABAJO")
                            return (<div className="badge badge-warning presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>);
                        else if (d.strestado == "AVANZADO A PRESUPUESTO")
                            return (<div className="badge badge-success presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>);
                        else
                            return (<div className="badge badge-primary presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>);
                    },
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        edit: true,
                        permission: 'plandetrabajo_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'plandetrabajo_detail',
                        component: Detail,
                    },
                    {
                        edit: true,
                        permission: 'plandetrabajo_upload',
                        component: SubirDocumento,
                    },
                    {
                        edit: true,
                        permission: 'plandetrabajo_generate',
                        component: DescargarDoc,
                    },
                    {
                        edit: true,
                        permission: 'plandetrabajo_next',
                        component: Avanzar,
                    },
                ]}

                apiUrl={api.proyectos.plandetrabajo.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.plandetrabajo.export}
                title={"Planes de Trabajo"}
            />
        );
    }
}

export default PlanDeTrabajo;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento2/PlanDeTrabajo.js